import { useRecoilValue } from 'recoil';
import {
  FilteredLevels,
  FilteredRoles,
  FilteredSigungus,
  FilteredStacks,
} from '@/src/store/superstack/jobs/FilterStates';
import { useState } from 'react';
import { ApiUrls } from '@/data/superstack/ApiUrls';
import { api } from '@/src/utils/api';
import { handleServerError, checkValidations } from '@/src/utils/ss_utils';
import { SSModal } from '@/src/component/superstack/base/Modal';
import { InputGroup } from '@/src/component/superstack/base/InputGroup';
import { Input } from '@/src/component/superstack/base/Inputs';
import { Checkbox } from '@/src/component/superstack/base/Checkbox';
import { MSSModalFloat } from '@/src/component/superstack/base/MModal';
import { ChipFilterContainer } from '@/src/component/superstack/jobs/ChipFilterContainer';

import styles from '@/styles/superstack/jobs/modals/FilterSaveModal.module.scss';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const FilterSaveModal = ({ isFilterSaveModalOpen, setIsFilterSaveModalOpen, updateContainer }) => {
  const filteredStacks = useRecoilValue(FilteredStacks);
  const filteredRoles = useRecoilValue(FilteredRoles);
  const filteredLevels = useRecoilValue(FilteredLevels);
  const filteredSigungus = useRecoilValue(FilteredSigungus);

  const [name, setName] = useState('');
  const [notificationEnabled, setNotificationEnabled] = useState(false);

  const handleSubmit = async () => {
    const url = ApiUrls().find((url) => url.name === 'jobs_filters').url;
    const data_ = {
      name: name,
      notification_enabled: notificationEnabled,
      data: {
        filteredStacks: filteredStacks,
        filteredRoles: filteredRoles,
        filteredLevels: filteredLevels,
        filteredSigungus: filteredSigungus,
      },
    };
    const isFormValid = checkValidations([]);
    if (!isFormValid) {
      alert('유효한 입력 값인지 확인하세요.');
      return false;
    }
    try {
      await api.post(url, { ...data_ });
      await updateContainer();
    } catch (error) {
      handleServerError(error);
    }
  };

  return (
    <SSModal
      isOpen={isFilterSaveModalOpen}
      onSubmit={handleSubmit}
      onClose={() => {
        setIsFilterSaveModalOpen(false);
      }}
      customStyle={{ content: { width: '360px' } }}
      title="필터 저장"
      btnSubmitName={'저장하기'}
    >
      <form className={cx('filter-save-form')}>
        <ChipFilterContainer type={'all'} cx={cx} />
        <div className={cx('input-group')}>
          <InputGroup mode="default" size="lg" labelText="필터 이름" required={true}>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </InputGroup>
        </div>
        <div className={cx('input-group')}>
          <Checkbox
            size="sm"
            name="notificationEnabled"
            checked={notificationEnabled}
            updateContainer={() => setNotificationEnabled(!notificationEnabled)}
          >
            새 포지션 알림 받기
          </Checkbox>
          <div className={cx('help-text')}>이 필터의 새 포지션을 알림톡으로 알려드립니다.</div>
        </div>
      </form>
    </SSModal>
  );
};

const MFilterSaveModal = ({ isFilterSaveModalOpen, setIsFilterSaveModalOpen, updateContainer }) => {
  const filteredStacks = useRecoilValue(FilteredStacks);
  const filteredRoles = useRecoilValue(FilteredRoles);
  const filteredLevels = useRecoilValue(FilteredLevels);
  const filteredSigungus = useRecoilValue(FilteredSigungus);

  const [name, setName] = useState('');
  const [notificationEnabled, setNotificationEnabled] = useState(false);

  const handleSubmit = async () => {
    const url = ApiUrls().find((url) => url.name === 'jobs_filters').url;
    const data_ = {
      name: name,
      notification_enabled: notificationEnabled,
      data: {
        filteredStacks: filteredStacks,
        filteredRoles: filteredRoles,
        filteredLevels: filteredLevels,
        filteredSigungus: filteredSigungus,
      },
    };
    const isFormValid = checkValidations([]);
    if (!isFormValid) {
      alert('유효한 입력 값인지 확인하세요.');
      return false;
    }
    try {
      await api.post(url, { ...data_ });
      await updateContainer();
    } catch (error) {
      alert(error?.response?.data?.message || error.message || error);
    }
  };

  return (
    <MSSModalFloat
      isOpen={isFilterSaveModalOpen}
      onSubmit={handleSubmit}
      onClose={() => {
        setIsFilterSaveModalOpen(false);
      }}
      title="필터 저장"
      btnSubmitName={'저장하기'}
    >
      <form className={cx('filter-save-form')}>
        <ChipFilterContainer type={'all'} cx={cx} />
        <div className={cx('input-group')}>
          <InputGroup mode="default" size="lg" labelText="필터 이름" required={true}>
            <Input
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          </InputGroup>
        </div>
        <div className={cx('input-group')}>
          <Checkbox
            size="sm"
            name="notificationEnabled"
            checked={notificationEnabled}
            updateContainer={() => setNotificationEnabled(!notificationEnabled)}
          >
            새 포지션 알림 받기
          </Checkbox>
          <div className={cx('help-text')}>이 필터의 새 포지션을 알림톡으로 알려드립니다.</div>
        </div>
      </form>
    </MSSModalFloat>
  );
};

export { FilterSaveModal, MFilterSaveModal };
